import { PageRef } from 'providers/page-ref';

export type HelpPageParams = {};

export const IHelpPage: PageRef<HelpPageParams, void> = {
  pageName: 'HelpPage',
} as PageRef<HelpPageParams, void>;
